import { type ComponentPropsWithRef } from 'react';
import { useTranslation } from 'react-i18next';

import { clsx } from '~/styles/utils';

import { Icon } from '../Icon/Icon';
import { useNavigationContext } from './Navigation.context';
import { buttonIconCollapsedStyle, buttonIconStyle, buttonStyle, itemStyle } from './Navigation.css';
import { NavigationTooltip } from './NavigationTooltip';

type Props = ComponentPropsWithRef<'button'>;

export const NavigationCollapse = ({ className, ...delegated }: Props) => {
  const { t } = useTranslation(['common']);
  const { isCollapsed, showLabels, toggleCollapsed } = useNavigationContext();

  const expandLabel = t('common:sidebar.expandMenu');
  const collapseLabel = t('common:sidebar.minimalizeMenu');
  const label = showLabels ? collapseLabel : expandLabel;

  return (
    <NavigationTooltip tooltip={label}>
      <button {...delegated} aria-label={label} className={clsx(itemStyle, buttonStyle, className)} onClick={toggleCollapsed} type="button">
        <Icon className={clsx(buttonIconStyle, isCollapsed && buttonIconCollapsedStyle)} name="BottomPanelOpen" />

        {showLabels && <span>{label}</span>}
      </button>
    </NavigationTooltip>
  );
};
